import { ProjectIntegrationService } from '@payaca/types/projectIntegrationTypes';

export const readableProjectIntegrationService: Record<
  ProjectIntegrationService,
  string
> = {
  EASY_PV: 'Easy PV',
  OPEN_SOLAR: 'OpenSolar',
  HEATPUNK: 'Heatpunk',
  FORNAX: 'Fornax',
  SPRUCE: 'Spruce',
};
